/** Partes proporcionales para flex (home vs away); vacío → barra neutra. */
export function dualBarFlexParts(home, away) {
  const h = Math.max(0, Number(home) || 0);
  const a = Math.max(0, Number(away) || 0);
  const t = h + a;
  if (t <= 0) {
    return { homeFlex: 1, awayFlex: 1, isEmpty: true };
  }
  return { homeFlex: h, awayFlex: a, isEmpty: false };
}

/** Máx. 4 caracteres en pantalla: enteros hasta 9999; con `%` el número se limita a 999 ("999%"). */
const STAT_VALUE_DISPLAY_MAX = 9999;
const STAT_PERCENT_DISPLAY_MAX = 999;

function clampStatDisplayValue(value, isPercent) {
  const n = Math.max(0, Math.floor(Number(value) || 0));
  return Math.min(n, isPercent ? STAT_PERCENT_DISPLAY_MAX : STAT_VALUE_DISPLAY_MAX);
}

export function formatStatValue(value, isPercent) {
  const n = clampStatDisplayValue(value, isPercent);
  if (isPercent) {
    return `${n}%`;
  }
  return String(n);
}

const TEAM_STATS_ROW_MAP = [
  { label: 'Tiros totales', key: 'shotsTotal' },
  { label: 'Tiros a portería', key: 'shotsOnGoal' },
  { label: 'Tiros fuera', key: 'shotsWide' },
  { label: 'Tiros bloqueados', key: 'shotsBlocked' },
  { label: 'Paradas del portero', key: 'savesByGoalkeeper' },
  { label: 'Tarjetas rojas', key: 'cardsRed' },
  { label: 'Tarjetas amarillas', key: 'cardsYellow' },
  { label: 'Faltas cometidas', key: 'fouls' },
  { label: 'Entradas ganadas', key: 'tacklesWon', secondaryBand: true },
  { label: 'Pases totales', key: 'passesTotal' },
  { label: 'Precisión de pases', key: 'passAccuracy', isPercent: true },
  { label: 'Saques de esquina', key: 'corners' },
  { label: 'Fuera de juego', key: 'offsides' },
];

function parseStatNumber(value) {
  if (value == null || value === '') return 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

/**
 * A partir de `matchDetailsData` (nivel `data` del servicio) usa `teamStatistics[0]`
 * con pares `home` / `away` tal como en `matchDetailsMock.json`.
 * @returns {{ possession: { home: number, away: number }, rows: object[] } | null}
 */
export function mapMatchDetailsToMatchStats(matchDetailsData) {
  const block = matchDetailsData?.teamStatistics?.[0];
  if (!block?.home || !block?.away) return null;

  const h = (key) => Math.max(0, parseStatNumber(block.home[key]));
  const a = (key) => Math.max(0, parseStatNumber(block.away[key]));

  return {
    possession: {
      home: h('ballPossession'),
      away: a('ballPossession'),
    },
    rows: TEAM_STATS_ROW_MAP.map((row) => ({
      statKey: row.key,
      label: row.label,
      home: h(row.key),
      away: a(row.key),
      ...(row.isPercent ? { isPercent: true } : {}),
      ...(row.secondaryBand ? { secondaryBand: true } : {}),
    })),
  };
}
